import React from "react";
import FileDownload from "js-file-download";
import axios from "axios";

export const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;

//Fetch ClientFilingTrackerComments
export const fetchClientFilingTrackerComments = async (
  fileTrackingID,
  customerId
) => {
  try {
    let url = `${API_BASE_URL}/Customer/ViewParentandchildCustomerCommentsandAttachments?fileTrackingIds=${fileTrackingID}&customerIds=${customerId}`;
    let url2 = `${API_BASE_URL}/Customer/ViewChildCustomerFilingTrackingComments?fileTrackingIds=${fileTrackingID}`;

    const res = await axios.get(url);
    const res2 = await axios.get(url2);
    // console.log("fetchClientFilingTrackerComments res", res.data.data, res2);

    let combinedRes = [...res.data.data, ...res2.data];
    console.log("fetchClientFilingTrackerComments combinedRes", combinedRes);
    return combinedRes;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Create TrackerCommentAttachment
export const createTrackerCommentAttachment = async (payload, customerId) => {
  try {
    const formData = new FormData();
    formData.append("Files", payload.Files);
    formData.append("Commenttext", payload.Commenttext);
    formData.append("filingId", payload.filingId);
    formData.append("FileTrackingId", payload.FileTrackingId);
    formData.append("createUser", payload.createUser);

    let url = `${API_BASE_URL}/Application/UpdateChildCustomerFilingTrackingCommentsAttachments?CustomerIds=${customerId}`;

    const res = await axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    console.log("createTrackerCommentAttachment res", res);
    return res.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Update TrackerComment
export const updateTrackerComment = async (payload) => {
  try {
    let res = await axios.put(
      `${API_BASE_URL}/Customer/UpdateCommentsOnly`,
      payload
    );

    // console.log("updateTrackerComment res", res);
    return res.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Delete CommentsOnly
export const deleteCommentsOnly = async (payload) => {
  try {
    let res = await axios.delete(
      `${API_BASE_URL}/Customer/DeleteCommentsOnly`,
      { data: payload }
    );

    // console.log("deleteCommentsOnly res", res);
    return res.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Delete CommentsandAttachment
export const deleteCommentsAndAttachment = async (
  payload,
  customerId,
  filingId
) => {
  try {
    let res = await axios.delete(
      `${API_BASE_URL}/Application/DeleteCommentsandAttachment?CustomerId=${customerId}&FilingId=${filingId}&FileTrackingId=${payload.fileTrackingId}&CommentsId=${payload.commentsId}&AttachmentId=${payload.attachmentId}`
    );

    // console.log("deleteCommentsandAttachment res", res);
    return res.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Download TrackerCommentAttachment
export const downloadTrackerCommentAttachment = async (
  commentData,
  filingId,
  fileName
) => {
  try {
    axios({
      url: `${API_BASE_URL}/Application/DownloadAttachment?AttachmentId=${commentData.attachmentId}&CustomerId=${commentData.customerId}&CommentsId=${commentData.commentsId}&FilingId=${filingId}&FileTrackingId=${commentData.fileTrackingId}`,
      method: "POST",
      responseType: "blob", // Important
    }).then((response) => {
      FileDownload(response.data, fileName);
    });
    return;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};
